export enum AccordionEvent {
    INIT = 'accordion:init'
}
